<script setup lang="ts">
import { onMounted, ref } from 'vue'
import layer from './components/layout/Layout.vue'
import list from './components/coinsList/CoinsList.vue'
import { coinsEvent } from '@/utils/track/coins'
import { trackSmFingerprint } from '~/composables/useSMFingerprint'

const { t } = useLang()
useHead({
  title: t('coins.p_coins_title'),
  meta: [
    { name: 'keywords', content: t('common.b_tdk_keywords') },
    { name: 'description', content: t('common.b_tdk_description') },
    { name: 'author', content: t('common.b_author') },
    { name: 'copyright', content: t('common.b_company') },
  ],
  script: [],
})

const activeIndex = ref(0)

onMounted(() => {
  // console.log('activeIndex')
  coinsEvent.pageShowEvent()

  trackSmFingerprint({})
})
</script>

<template>
  <div class="coins flex flex-col">
    <layer />
    <list class="flex-1" />
  </div>
</template>

<style scoped lang="scss">
.coins {
  min-height: calc(100vh - 240px);
  background-color: #f3f3f3;
}
</style>
